import { addBasketItemsWithSpinner } from "lib/api/addBasketItems";
import { useNMCustomerJourney } from "packages/acquisition/components/GuestPrice/hooks/useNMCustomerJourney";
import { ProductCard } from "packages/core-shopping/components/ProductCardV2";
import React from "react";
import { trackClicked } from "tracking/utils/trackClicked";
import type {
  ProductCardProduct,
  RecommendationItem
} from "@shared/graphql.types";
import { productCardWrapper } from "../RecommendationModule.css";

const RecommendationProductButton = ({
  item,
  onAddToBag,
  locationType
}: {
  item: RecommendationItem;
  onAddToBag?: (product: ProductCardProduct) => void;
  locationType: string;
}) => {
  const {
    cta: { text, tracking, variant },
    product
  } = item;

  const isNMCustomerJourney = useNMCustomerJourney();

  const onClick = async () => {
    //TODO: check cta.actionType before doing add to bag when we have more cases, currently we support "ADD_TO_BAG"

    await addBasketItemsWithSpinner(
      [
        {
          variantId: product.id,
          quantity: 1,
          type: "product",
          origin: "user",
          variantSku: product.sku
        }
      ],
      locationType
    );

    trackClicked(tracking?.clicked);
    onAddToBag?.(product);
  };

  const buttonText = text.replace(
    "{{price}}",
    isNMCustomerJourney
      ? item.product.secondaryPrice
      : item.product.primaryPrice
  );

  return (
    <ProductCard.Button
      variant={variant || "tertiary"}
      product={{ buttonText, isPrimaryButtonDisabled: false }}
      onClick={onClick}
    />
  );
};

export const Product = ({
  item,
  onAddToBag,
  locationType
}: {
  item: RecommendationItem;
  onAddToBag?: (product: ProductCardProduct) => void;
  locationType: string;
}) => {
  const { product, tracking } = item;

  const onProductClick = () => {
    trackClicked(tracking?.clicked, { isRedirectAction: true });
  };

  return (
    <div data-product-result="constructor" className={productCardWrapper}>
      <ProductCard product={product} onClick={onProductClick}>
        <ProductCard.Header>
          <ProductCard.Image product={product} />
        </ProductCard.Header>
        <ProductCard.Body>
          <ProductCard.Rating product={product} />
          <ProductCard.BrandName product={product} />
          <ProductCard.ProductName product={product} />
          <ProductCard.VariationName product={product} />
        </ProductCard.Body>
        <ProductCard.Footer>
          <RecommendationProductButton
            onAddToBag={onAddToBag}
            item={item}
            locationType={locationType}
          />
        </ProductCard.Footer>
      </ProductCard>
    </div>
  );
};
